var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtml5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91014 21.6082L1 0H22L20.0899 21.5965L11.4826 24",
    fill: "#E44D26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4999 22.1626V1.77368H20.084L18.4459 20.2083",
    fill: "#F16529"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90131 4.41626H11.5V7.06478H7.78389L8.027 9.77747H11.5V12.4201H5.61906L4.90131 4.41626ZM5.73482 13.7502H8.37429L8.55952 15.8679L11.5 16.6613V19.4265L6.10528 17.9097",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0754 4.41626H11.4883V7.06478H17.8323L18.0754 4.41626ZM17.595 9.77747H11.4883V12.426H14.7297L14.423 15.8679L11.4883 16.6613V19.4148L16.8714 17.9097",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml5);
export default __webpack_public_path__ + "static/media/html5.0d83e1831659dc17c6f27880d585072e.svg";
export { ForwardRef as ReactComponent };